<template>
    <div class="home Home.vue">
      <div class="content">
        <div class="home__logo">
          <logo/>
        </div>
        <!-- /.logo -->
        <div class="line1 animated fadeInDown">{{ salutation }}!</div>
        <div class="line2 animated fadeInDown">Qual seu nome?</div>
        <div class="input-block fake-label animated fadeInDown">
          <input v-fakelabel v-model="name" id="name" type="text" @keyup="enterKeyPressed" class="form-control" placeholder="Nome">
          <label for="name">Nome</label>
        </div>
        <button @click="setGuestName()" class="btn btn-bold animated fadeIn">OK <i class="arrow simple"></i>
          <!-- /.arrow simple --></button>
        <!-- /.btn btn-bold -->
        <!-- /.input-block -->
      </div>
      <!-- /.content -->

      <button @click="guestEnter" class="btn btn-bold btn-guest animated fadeIn">Não quero informar meu nome <i class="arrow simple"></i></button>


      <p class="company">
        <span class="f-partners text-center">
          <a href="https://www.kommo.com/" target="_blank"><img width="100" height="44" src="/static/kommo.svg" alt="Kommo"></a>
        </span>
        <!-- /.partners -->
        H&T DESENVOLVIMENTO WEB LTDA - ME CNPJ: 18.106.092/0001-54 Rua Dona Magina Pontual, 384, Boa Viagem - Recife - PE CEP: 51.021-510
      </p>
      <!-- /.company -->

    </div>
</template>

<script>

//  import MainMenu from './MainMenu.vue'
  import logo from '../assets/logo.svg'
  import Snap from 'snapsvg';
  import store from '../store';
  import checkMark from './checkMark.vue';

  export default {
    name: 'Home',
    data() {
      return {
        salutation: this.getSalutation(),
        name: ''
      }
    },
    computed:{
      count(){
        return store.state.count;
      },
      guestName (){
        return store.state.guestName
      }
    },

    mounted() {
      this.log('mounted: ' + this.$options.name);
      // document.querySelector('title').innerText = '<bold>';

      // seta a classe do menu principal
      this.$store.commit('setMenuClass', 'minimal');

      let arrowLeft = Snap(".home #seta-1");
      let arrowRight = Snap(".home #seta-2");
      let maskB = Snap('.home #mascara');

      let letterB = Snap('.home #letter-b');
      let letterO = Snap('.home #letter-o');
      let letterL = Snap('.home #letter-l');
      let letterD = Snap('.home #letter-d');

      // remove from view
      letterO.transform('t50');
      letterL.transform('t-160');
      letterD.transform('t-250');

      // set initial positions
      maskB.transform('t250');
      letterB.transform('t250');
      arrowRight.transform('t-280');
      arrowLeft.transform('t280');

      let animationSpeed = 400;

      setTimeout(() => {
        // arrows
        arrowRight.animate({transform: 't0'}, animationSpeed, mina.easeinout);
        arrowLeft.animate({transform: 't0'}, animationSpeed, mina.easeinout);

        maskB.animate({transform: 't0'}, animationSpeed, mina.easeinout);
        letterB.animate({transform: 't0'}, animationSpeed, mina.easeinout);
        letterO.animate({transform: 't0'}, animationSpeed, mina.easeinout);
        letterL.animate({transform: 't0'}, animationSpeed, mina.easeinout);
        letterD.animate({transform: 't0'}, animationSpeed, mina.easeinout);
      }, 1000);

    },
    components: {
      logo,
      checkMark,
    },
    methods: {
      /**
       * Retorna a mss de boa vindas de acordo com a hora do dia
       * @returns {string}
       */
      guestEnter() {
        store.commit('setGuestName', '');
        this.$router.push('guest');
      },
      getSalutation() {
        let msg = 'Boa noite';
        let currentHour = (new Date).getHours();
        if (currentHour >= 5 && currentHour < 12){
          msg = 'Bom dia';
        }else if (currentHour >= 12 && currentHour < 18){
          msg = 'Boa tarde';
        }
        return msg;
      },
      setGuestName(){
        let name = this.name.replace(/ /g,'');
        if (!name){
          alert('Entre com seu nome!');
          this.name = '';
          return;
        }
        store.commit('setGuestName', this.name);
        this.$router.push('guest');
      },
      enterKeyPressed(event){
        if (event.keyCode === 13) {
          this.setGuestName();
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.company{
  position: absolute;
  bottom: 15px;
  font-size: 12px;
  left: 0;
  right: 0;
  max-width: 90%;
  margin: 0 auto;
}

.f-partners{
  margin-bottom: 20px;
  display: block;
}

@media all and (max-width: 320px) {
  .company{
    font-size: 10px;
  }
}

@media all and (max-width: 900px) and (max-height: 700px) {
  .home .content{
    margin-bottom: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue